<template>
  <div>
    <Selector
      id="challenge-selector"
      name="challenge"
      label="Sélectionnez un challenge"
      v-model="selectedChallenge"
      :options="challengeOptions"
      required
    />
    <Selector
      v-if="selectedChallenge"
      id="store-selector"
      name="store"
      label="Sélectionnez un magasin"
      v-model="selectedStoreId"
      :options="storeOptions"
      required
    />
    <div class="mt-4 space-y-4" v-if="selectedStoreId">
      <Table :columns="storeTableColumns" :data="storeTableData" />
      <Table :columns="sellerTableColumns" :data="sellerTableData" />
    </div>
  </div>
</template>

<script>
import { Selector, Table, toCamelCase } from "@estaly/ui";
import { mapActions } from "vuex";

export default {
  components: {
    Selector,
    Table,
  },
  data() {
    return {
      challenges: [],
      selectedChallenge: "",
      selectedStoreId: null,
      store: null,
      sellers: [],
    };
  },
  computed: {
    challengeOptions() {
      return this.challenges.map((challenge) => ({
        label: `${challenge.id} ${challenge.title || ""}`,
        value: challenge.id,
      }));
    },
    selectedChallengeData() {
      return this.challenges.find((c) => c.id === this.selectedChallenge);
    },
    storeOptions() {
      const stores = this.selectedChallengeData?.stores || [];
      return stores.map((store) => ({
        label: store.salesChannel,
        value: store.id,
      }));
    },
    storeTableColumns() {
      return [
        { field: "salesChannel", label: "Magasin", bold: true },
        { field: "email", label: "Email" },
        { field: "score", label: "Score", numeric: true },
        { field: "rewardAmount", label: "Gain", numeric: true, price: true },
      ];
    },
    storeTableData() {
      return this.store
        ? [
            {
              salesChannel: this.store.salesChannel,
              email: this.store.email,
              score: this.store.storeScore,
              rewardAmount: this.store.storeRewardAmount,
            },
          ]
        : [];
    },
    sellerTableColumns() {
      return [
        { field: "name", label: "Vendeur", bold: true },
        { field: "email", label: "Email" },
        { field: "score", label: "Score", numeric: true },
        { field: "rewardAmount", label: "Gain", numeric: true, price: true },
      ];
    },
    sellerTableData() {
      return this.sellers.map((seller) => ({
        name: seller.name,
        email: seller.email,
        score: seller.score,
        rewardAmount: seller.rewardAmount,
      }));
    },
  },
  async mounted() {
    await this.retrieveChallenges();
  },
  watch: {
    selectedChallenge() {
      this.selectedStoreId = null;
      this.store = null;
      this.sellers = [];
    },
    async selectedStoreId(newStoreId) {
      if (newStoreId) await this.retrieveChallengePerformances();
    },
  },
  methods: {
    ...mapActions("challenges", ["fetchIndex", "getPerformance"]),
    async retrieveChallenges() {
      const data = await this.fetchIndex({ includes: ["stores"], perPage: 2000 });
      if (!data) {
        this.challenges = [];
        return;
      }
      this.challenges = Array.isArray(data.challenges) ? data.challenges : [];
    },
    async retrieveChallengePerformances() {
      const response = await this.getPerformance({
        storeId: this.selectedStoreId,
        challengeId: this.selectedChallenge,
      });
      if (response?.success) {
        const data = toCamelCase(response.data);
        this.store = data.performance.storePerformance;
        this.sellers = data.performance.sellers;
      }
    },
  },
};
</script>
